import React from 'react';
import {
  LBButton,
  LBCard,
  LBCardContent,
  LBCardDescription,
  LBCardHeader,
  LBCardTitle
} from '@linearb/buzz';
import { OnboardingCardConfig } from './onboardingConfig';

interface OnboardingCardProps extends OnboardingCardConfig {
  onButtonClick: () => void;
}

const OnboardingCard: React.FC<OnboardingCardProps> = ({
  title,
  description,
  additionalInfo,
  buttonText,
  onButtonClick,
  imageSrc,
  imageAlt,
  gradientClasses
}) => {
  return (
    <LBCard className='h-[600px] flex flex-col overflow-hidden rounded-2xl border-gray-200'>
      {/* Illustration Container */}
      <div className={`h-64 relative overflow-hidden ${gradientClasses}`}>
        <img
          src={imageSrc}
          alt={imageAlt}
          className='absolute inset-0 w-full h-full object-cover'
        />
      </div>

      <LBCardHeader className='pb-2'>
        <LBCardTitle className='text-xl font-semibold text-gray-900'>
          {title}
        </LBCardTitle>
      </LBCardHeader>

      <LBCardContent className='flex flex-col flex-grow'>
        <div className='flex-grow space-y-4'>
          <LBCardDescription className='text-sm text-gray-600 leading-relaxed'>
            {description}
          </LBCardDescription>

          <p className='text-sm text-gray-600 leading-relaxed'>
            {additionalInfo}
          </p>
        </div>

        <div className='mt-auto pt-6'>
          <LBButton
            onClick={onButtonClick}
            className='px-6 py-2'
            variant='default'
          >
            {buttonText}
          </LBButton>
        </div>
      </LBCardContent>
    </LBCard>
  );
};

export default OnboardingCard;
